module.exports = __webpack_public_path__ + "school/img/jiaoxuezhuangqu3ji.cef50921.jpg";